import React, { useRef } from "react";
import { Menu } from "primereact/menu";
import useRolePermissionServices from "../../hooks/useRolePermissionServices";
import _ from 'lodash'

const ProWaitlistClientActionMenu = ({data, performAction})=>{ 
    const {data:{WaitlistRoles}} = useRolePermissionServices()
    const menuRef = useRef(null); 
    const editLabel = _.get(data, "pendingClientName")? "Edit Pending Client": "Edit Client"
    const removeLabel = _.get(data, "pendingClientName")? "Remove Pending Client": "Remove Client"
    const editSideBarLabel = _.get(data, "pendingClientName")? "Edit Waitlist Pending Client": "Edit Waitlist Client" 

    const actionItems = [{label: `${editLabel}`, icon: 'fas fa-edit', command:(e)=> performAction("EDIT", `${editSideBarLabel}`, data)},
                         {label: `${removeLabel}`, icon: 'fas fa-trash', command:(e)=> performAction("REMOVE", "Remove Client Waitlist", data)}]
    if(WaitlistRoles.canModifyWaitlistClient) {                    
        return (
            <div>
                <i className="pi pi-ellipsis-h cursor-pointer"  onClick={(event) => {menuRef && menuRef.current.toggle(event); event.preventDefault()}} ></i> 
                <Menu  model={actionItems} popup ref={menuRef} />
            </div>
        )
    }
    else{
        return <></>
    }

}

export default ProWaitlistClientActionMenu;